import React, { useContext, useState } from "react";
import { Table, Button, Card } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import useApi from "../../hooks/useApi";
import useFilter from "../../hooks/useFilter";
import usePermissions from "../../hooks/usePermissions";
import { permissionKeys } from "../../constants/staffRole";
import { AppStateContext } from "../../context/AppContext";
import { BranchListBelt } from "../../constants/API/API";

const Belt = () => {
  const { setPageHeading } = useContext(AppStateContext);
  setPageHeading("Belt Management");

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);

  const [filters, setFilters] = useFilter({
    sortField: "createdAt",
    sort: "desc",
  });

  const handleView = (record) => {
    navigate(`/branch-belts/${record._id}`);
  };

  useApi({
    callback: BranchListBelt,
    payload: filters,
    dependencies: [filters],
    shouldCallApi: true,
    onSuccess: ({ data, totalDocs }) => {
      setData(data);
      setTotalDocs(totalDocs);
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });

  const columns = [
    {
      title: "Branch Name",
      dataIndex: "branchName",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (val) => (val ? "Active" : "Inactive"),
    },
    {
      title: "Total Belts",
      dataIndex: "totalBelts",
    },
    {
      title: "Active Belts",
      dataIndex: "totalActiveBelts",
    },
    {
      title: "Inactive Belts",
      dataIndex: "totalInactiveBelts",
    },
    {
      title: "Total KYUs",
      dataIndex: "totalKyus",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Button
          type="primary"
          icon={<EyeOutlined />}
          onClick={() => handleView(record)}
        >
          View
        </Button>
      ),
    },
  ];

  return (
    <Card>
      <div className="table-responsive customPagination">

        <Table
          rowKey="_id"
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{
            total: totalDocs,
            pageSize: 10,
          }}
        />
      </div>
    </Card>

  );
};

export default Belt;
